
import { booleanRadioOptions, BoolStringEnum, emailFormatMessage, messageRequired, MetadataType, numberFormat, numberFormatLength, TemplateTypeEnum, TrctProposePhotosQuestionEnum, UNIPOLSAI_COMPLETE, UNIPOLSAI_COMPLETE_CODE, ValueLabelOption } from "../commonTypes";
import * as yup from "yup";
import moment from "moment";
import { BaremeResponses } from "./caiType";
import { SignCaiBodyType } from "./sign-type";

export enum UserRoleEnum {
    USER_1 = 'USER_1',
    CTP = 'CTP'
}

export enum CaiCaseEnum {
    CASE_1A = 'CASE_1A',
    CASE_1B = 'CASE_1B',
    CASE_2 = 'CASE_2',
    CASE_L = 'CASE_L',
}

export class CommunicationDataType {
    // Result Data
    public aniaoptions: AniaItemType[] = [];
    public captchaChallenge: boolean = false;
    public ctp: CommunicationType = new CommunicationType();
    public communication: CommunicationType = new CommunicationType();
    public loadCommunicationMetadata: MetadataType = new MetadataType()
    public caiValidationInfo: CaiValidationInfoType = new CaiValidationInfoType()
    public invokeSignatureMetadata: MetadataType = new MetadataType()
    public saveCommunicationMetadata: MetadataType = new MetadataType()
    //linear
    public driverValidationInfo: LinearDriverValidationInfoType = new LinearDriverValidationInfoType()
    public agreeValidationInfo: LinearValidationInfoType = new LinearValidationInfoType()

    constructor(input?: any) {
        if (input) {
            this.aniaoptions = input.aniaoptions?.map((el: any) => new AniaItemType(el)) || [];
            this.captchaChallenge = input.captchaChallenge || false;
            this.ctp = new CommunicationType(input.ctp);
            this.communication = new CommunicationType(input.communication);
            this.loadCommunicationMetadata = new MetadataType(input.loadCommunicationMetadata)
            this.caiValidationInfo = new CaiValidationInfoType(input.caiValidationInfo);
            this.invokeSignatureMetadata = new MetadataType(input.invokeSignatureMetadata)
            this.saveCommunicationMetadata = new MetadataType(input.saveCommunicationMetadata)
            // linear
            this.driverValidationInfo = new LinearDriverValidationInfoType(input.driverValidationInfo);
            this.agreeValidationInfo = new LinearValidationInfoType(input.agreeValidationInfo);
        }
    }
}

export class CaiValidationInfoType {
    public y_contactInfo?: boolean;
    public n_contactInfo?: boolean;
    public y_ctp_contactInfo?: boolean;
    public n_ctp_contactInfo?: boolean;
    public dn_ctp_contactInfo?: boolean;

    constructor(input?: any) {
        if (input) {
            this.y_contactInfo = input.y_contactInfo;
            this.n_contactInfo = input.n_contactInfo;
            this.y_ctp_contactInfo = input.y_ctp_contactInfo;
            this.n_ctp_contactInfo = input.n_ctp_contactInfo;
            this.dn_ctp_contactInfo = input.dn_ctp_contactInfo;
        }
    }
}

export class LinearValidationInfoType {
    public agree_contactInfo?: boolean;

    constructor(input?: any) {
        if (input) {
            this.agree_contactInfo = input.agree_contactInfo;
        }
    }
}

export class LinearDriverValidationInfoType {
    public conducente_contactInfo?: boolean;

    constructor(input?: any) {
        if (input) {
            this.conducente_contactInfo = input.conducente_contactInfo;
        }
    }
}

export enum BaremeUserChoiseEnum {
    BAREME_BATCH_ACCEPTED = 'BAREME_BATCH_ACCEPTED',
    BAREME_QUESTIONS_FILLED_ACCEPTED = 'BAREME_QUESTIONS_FILLED_ACCEPTED',
    BAREME_FREE_DESCRIPTION = 'BAREME_FREE_DESCRIPTION'
}

type PlaceholderValuesType = {
    plate?: string
}

type EvMetadataType = {
    sid?: string
    body?: any
    outcome?: any
}

export enum NoSignReasonEnum {
    INCORRECT_DOCUMENTS = 'INCORRECT_DOCUMENTS',
    SHOULD_NOT_BE_INVOLVED = 'SHOULD_NOT_BE_INVOLVED',
    OTHER = 'OTHER'
}

export enum ClaimConfirmedEnum {
    CLAIM_CONFIRMED = 'CLAIM_CONFIRMED',
    CLAIM_NOT_CONFIRMED = 'CLAIM_NOT_CONFIRMED',
    NOT_ANSWERED = 'NOT_ANSWERED',
}

export enum TrctEsitoRaccoltaFotoEnum {
    COMPLETA = 'completa',
    INCOMPLETA = 'incompleta'
}

export const getDefaultCtpCompAssic = (input: any) => {
    if (input?.type?.indexOf(TemplateTypeEnum.SIN_INAT) >= 0) {
        return UNIPOLSAI_COMPLETE
    }
    return ""
}

export const getDefaultCtpCompAssicCode = (input: any) => {
    if (input?.type?.indexOf(TemplateTypeEnum.SIN_INAT) >= 0) {
        return UNIPOLSAI_COMPLETE_CODE
    }
    return ""
}

export class CommunicationType {
    public to: string = '';
    public cloned_to: string = '';
    public companyName: string = '';
    public content: string = '';
    public placeholderValues: PlaceholderValuesType = {};
    public contentData: PlaceholderValuesType = {};
    public _id: string = '';
    public company_code: string = '';
    public type: string = '';
    public ibanAddress: string = '';
    public inc_utc_time: string = '';
    public airbagScoppiati?: BoolStringEnum;
    public veicoloMarciante?: BoolStringEnum;
    public inc_data: string = '';
    public hrm_message_id: string = '';
    public assic_cfpiva: string = '';
    public bareme_src: string = '';
    public disable_step_10?: boolean;
    public comp_indirizzo: string = '';
    public crash_id: string = '';
    public comp_agenzia_nome: string = '';
    public assic_stato: string = '';
    public comp_polizza: string = '';
    public assic_cognome: string = '';
    public bareme_desc: string = '';
    public assic_indirizzo: string = '';
    public comp_agenzia_code: string = '';
    public assic_cap: string = '';
    public veic_targa: string = '';
    public assic_email: string = '';
    public tel_o_mail: string = '';
    public veic_marca: string = '';
    public cai_side: string = '';
    public comp_certificato_dal: string = '';
    public main_impact_point?: ZonaUrtoEnum;
    public inc_luogo: string = '';
    public comp_certificato_al: string = '';
    public comp_agenzia_denominazione: string = '';
    public inc_latitude: string = '';
    public cp_veic_targa: string = '';
    public update_date: string = '';
    public inc_longitude: string = '';
    public original_cp_veic_targa: string = '';
    public assic_nome: string = '';
    public phone_number: string = '';
    public correlated_crash_id: string = '';
    public assic_tel_o_email: string = '';
    public inc_ora: string = '';
    public cai_digital_ending_date: string = '';
    public token: string = '';
    public ctpToken: string = '';
    public mainUserToken: string = '';
    public creation_date: string = '';
    public interactions: InteractionType[] = [];
    public comp_tel_o_email: string = '';
    public events: EventCommType[] = [];
    public file_download_tecnico_id: string = '';
    public onlyInternal: boolean = false;
    public file_download_cai_id: string = '';
    public userRole?: UserRoleEnum;
    public caiCaseEnum?: CaiCaseEnum;
    public caiData?: SignCaiBodyType;
    public phoneCtp: string = '';
    public caiAcceptanceIpernaturale: boolean = false;
    public previewSecondPageVisible?: boolean;
    public curtUrl: string = '';
    public force_invalidated?: boolean;

    // ui created
    public numOfPasssengers: number = 0;
    public cp_compagnia_assic: string = ""
    public cp_compagnia_assic_code: string = ""
    public numOfVeichles: number = 2;
    public lastPathname: string = ''
    public baremeUserChoise?: BaremeUserChoiseEnum;
    public noClaimWhatHappened?: ValueLabelOption<string>;
    public baremeFreeDescription: string = ''
    public fotoContestoList: FileItemType[] = []
    public fotoDanniList: FileItemType[] = []
    public forceLastPathname: string = ''
    public fotoOtherUsefulInfo: FileItemType[] = []
    public fotoCruscotto: FileItemType[] = []
    public fotoPatente: FileItemType[] = []
    public fotoDanniCtpList: FileItemType[] = []
    public fotoAngolareVeicolo: FileItemType[] = []
    public conducenteInfo: ConducenteInfo = new ConducenteInfo()
    public rimorchioInfo: RimorchioInfo = new RimorchioInfo()
    public fotoCartaCircolazione: FileItemType[] = []
    public testimoniInfo: OtherContactInfo = new OtherContactInfo()
    public altriVeicoliInfo: OtherContactInfo = new OtherContactInfo()
    public feritiInfo: OtherContactInfo = new OtherContactInfo()
    public controparteInfo: ControparteInfo = new ControparteInfo()
    public linearControparteInfo: LinearControparteInfo = new LinearControparteInfo()
    public oggettiDiversiInfo: OtherContactInfo = new OtherContactInfo()
    public zoneUrto: ZoneUrtoType[] = []
    public ctp_zoneUrto: ZoneUrtoType[] = []
    public linearConducenteInfo: LinearConducenteInfo = new LinearConducenteInfo()
    public baremeResponses: BaremeResponses = new BaremeResponses()
    public baremeInfo: BaremeInfo = new BaremeInfo()
    public allFiles: FileItemType[] = []
    public esitoRaccoltaFoto?: TrctEsitoRaccoltaFotoEnum = TrctEsitoRaccoltaFotoEnum.INCOMPLETA;
    public noSignReason?: NoSignReasonEnum;
    public authConfirmDocsList: FileItemType[] = []
    public linearAuthConfirmDocsList: FronteRetroFileItemType = new FronteRetroFileItemType()
    public witnessesStatsList: FileItemType[] = []
    public auth_confirm_input_veic_targa: string = '';

    public insuredLicenceDoc: FronteRetroFileItemType = new FronteRetroFileItemType()
    public denunciaDocsList: FileItemType[] = []
    public witnessesDocsList: FronteRetroFileItemType[] = []
    public driverLicenceList: FronteRetroFileItemType = new FronteRetroFileItemType()

    public ibanDocTxt: FileItemType[] = []
    public otherDocsList: FileItemType[] = []
    public caiPaperList: FileItemType[] = [];
    public inApp: boolean = false;
    public authConfirmPrivacyChecked: boolean = false;
    public tractableOn: boolean = false;
    public trctProposePhotosQuestion?: TrctProposePhotosQuestionEnum;
    public outcome?: string;
    public folder_id?: string = '';
    public isClaimConfirmed?: ClaimConfirmedEnum = ClaimConfirmedEnum.NOT_ANSWERED;
    public signatureInfo?: SignatureInfoType
    public mainImpactPoint?: ZonaUrtoEnum
    public ctpImpactPoint?: ZonaUrtoEnum

    public ctpTypeTarga?: TypeTargaEnum;

    constructor(input?: any) {
        if (input) {
            this.to = input.to;
            this.cloned_to = input.cloned_to;
            this._id = input._id;
            this.content = input.content;
            this.ibanAddress = input?.ibanAddress
            this.placeholderValues = input.placeholderValues;
            this.contentData = input.contentData;
            this.type = input.type;
            this.companyName = input.companyName;
            this.hrm_message_id = input.hrm_message_id;
            this.company_code = input.company_code;
            this.inc_utc_time = input.inc_utc_time;
            this.airbagScoppiati = input.airbagScoppiati;
            this.veicoloMarciante = input.veicoloMarciante;
            this.disable_step_10 = input.disable_step_10;
            this.comp_indirizzo = input.comp_indirizzo;
            this.bareme_src = input.bareme_src;
            this.comp_agenzia_nome = input.comp_agenzia_nome;
            this.inc_data = input.inc_data;
            this.assic_cognome = input.assic_cognome;
            this.assic_cfpiva = input.assic_cfpiva;
            this.assic_indirizzo = input.assic_indirizzo;
            this.assic_stato = input.assic_stato;
            this.comp_agenzia_code = input.comp_agenzia_code;
            this.bareme_desc = input.bareme_desc;
            this.assic_email = input.assic_email;
            this.crash_id = input.crash_id;
            this.comp_polizza = input.comp_polizza;
            this.veic_targa = input.veic_targa;
            this.assic_cap = input.assic_cap;
            this.main_impact_point = input.main_impact_point;
            this.veic_marca = input.veic_marca;
            this.comp_certificato_dal = input.comp_certificato_dal;
            this.inc_latitude = input.inc_latitude;
            this.inc_luogo = input.inc_luogo;
            this.cai_side = input.cai_side;
            this.comp_agenzia_denominazione = input.comp_agenzia_denominazione;
            this.correlated_crash_id = input.correlated_crash_id;
            this.comp_certificato_al = input.comp_certificato_al;
            this.update_date = input.update_date;
            this.original_cp_veic_targa = input.original_cp_veic_targa;
            this.assic_nome = input.assic_nome;
            this.tel_o_mail = input.tel_o_mail;
            this.cp_veic_targa = input.cp_veic_targa;
            this.inc_longitude = input.inc_longitude;
            this.assic_tel_o_email = input.assic_tel_o_email;
            this.inc_ora = input.inc_ora;
            this.creation_date = input.creation_date;
            this.phone_number = input.phone_number;
            this.token = input.token;
            this.ctpToken = input.ctpToken;
            this.force_invalidated = input.force_invalidated;
            this.events = ((input && input.events) || []).map((ev: any) => new EventCommType(ev))
            this.interactions = ((input && input.interactions) || []).map((ev: any) => new InteractionType(ev))
            this.cai_digital_ending_date = input.cai_digital_ending_date
            this.mainUserToken = input.mainUserToken;
            this.comp_tel_o_email = input.comp_tel_o_email
            this.file_download_tecnico_id = input.file_download_tecnico_id;
            this.onlyInternal = !!(input.onlyInternal)
            this.caiData = input.caiData
            this.userRole = input.userRole;
            this.file_download_cai_id = input.file_download_cai_id;
            this.caiCaseEnum = input.caiCaseEnum;
            this.phoneCtp = input?.phoneCtp
            this.caiAcceptanceIpernaturale = !!(input.caiAcceptanceIpernaturale)
            this.isClaimConfirmed = input.isClaimConfirmed || ClaimConfirmedEnum.NOT_ANSWERED
            this.previewSecondPageVisible = !!(input.previewSecondPageVisible)
            this.outcome = input?.outcome
            this.folder_id = input?.folder_id
            this.curtUrl = input?.curtUrl

            // ui created
            this.numOfPasssengers = input.numOfPasssengers || this.numOfPasssengers;
            this.cp_compagnia_assic = input.cp_compagnia_assic || this.cp_compagnia_assic || getDefaultCtpCompAssic(input);
            this.cp_compagnia_assic_code = input.cp_compagnia_assic_code || this.cp_compagnia_assic_code || getDefaultCtpCompAssicCode(input);
            this.lastPathname = input.lastPathname || this.lastPathname;
            this.numOfVeichles = input.numOfVeichles || this.numOfVeichles;
            this.baremeFreeDescription = input.baremeFreeDescription || this.baremeFreeDescription;
            this.noClaimWhatHappened = input && input.noClaimWhatHappened;
            this.forceLastPathname = input.forceLastPathname || this.forceLastPathname;
            this.rimorchioInfo = new RimorchioInfo(input.rimorchioInfo)
            this.baremeUserChoise = input && input.baremeUserChoise;
            this.fotoContestoList = ((input && input.fotoContestoList) || []).map((f: any) => new FileItemType(f))
            this.fotoOtherUsefulInfo = ((input && input.fotoOtherUsefulInfo) || []).map((f: any) => new FileItemType(f))
            this.fotoCruscotto = ((input && input.fotoCruscotto) || []).map((f: any) => new FileItemType(f))
            this.fotoDanniList = ((input && input.fotoDanniList) || []).map((f: any) => new FileItemType(f))
            this.fotoCartaCircolazione = ((input && input.fotoCartaCircolazione) || []).map((f: any) => new FileItemType(f))
            this.fotoDanniCtpList = ((input && input.fotoDanniCtpList) || []).map((f: any) => new FileItemType(f))
            this.fotoAngolareVeicolo = ((input && input.fotoAngolareVeicolo) || []).map((f: any) => new FileItemType(f))
            this.conducenteInfo = new ConducenteInfo(input.conducenteInfo)
            this.feritiInfo = new OtherContactInfo(input.feritiInfo)
            this.fotoPatente = ((input && input.fotoPatente) || []).map((f: any) => new FileItemType(f))
            this.testimoniInfo = new OtherContactInfo(input.testimoniInfo)
            this.altriVeicoliInfo = new OtherContactInfo(input.altriVeicoliInfo)
            this.controparteInfo = new ControparteInfo(input.controparteInfo)
            this.linearControparteInfo = new LinearControparteInfo(input.linearControparteInfo)
            this.linearConducenteInfo = new LinearConducenteInfo(input.linearConducenteInfo)
            this.zoneUrto = ((input && input.zoneUrto) || []).map((f: any) => new ZoneUrtoType(f))
            this.oggettiDiversiInfo = new OtherContactInfo(input.oggettiDiversiInfo)
            this.ctp_zoneUrto = ((input && input.ctp_zoneUrto) || []).map((f: any) => new ZoneUrtoType(f))
            this.noSignReason = input.noSignReason;
            this.baremeResponses = new BaremeResponses(input.baremeResponses)
            this.allFiles = ((input && input.allFiles) || []).map((f: any) => new FileItemType(f))
            this.esitoRaccoltaFoto = input.esitoRaccoltaFoto;
            this.auth_confirm_input_veic_targa = input.auth_confirm_input_veic_targa;
            this.authConfirmDocsList = ((input && input.authConfirmDocsList) || []).map((f: any) => new FileItemType(f))
            this.linearAuthConfirmDocsList = new FronteRetroFileItemType(input.linearAuthConfirmDocsList)
            this.baremeInfo = new BaremeInfo(input.baremeInfo)
            this.denunciaDocsList = ((input && input.denunciaDocsList) || []).map((f: any) => new FileItemType(f))

            this.witnessesStatsList = ((input && input.witnessesStatsList) || []).map((f: any) => new FileItemType(f))
            this.insuredLicenceDoc = new FronteRetroFileItemType(input.insuredLicenceDoc)
            this.witnessesDocsList = ((input && input.witnessesDocsList) || []).map((obj: any) => new FronteRetroFileItemType(obj))
            this.driverLicenceList = new FronteRetroFileItemType(input.driverLicenceList)

            this.ibanDocTxt = ((input && input.ibanDocTxt) || []).map((f: any) => new FileItemType(f))
            this.otherDocsList = ((input && input.otherDocsList) || []).map((f: any) => new FileItemType(f))
            this.caiPaperList = ((input && input.caiPaperList) || []).map((f: any) => new FileItemType(f))
            this.inApp = !!(input.inApp)
            this.authConfirmPrivacyChecked = !!(input.authConfirmPrivacyChecked)
            this.trctProposePhotosQuestion = input.trctProposePhotosQuestion
            this.tractableOn = !!(input.tractableOn)
            this.signatureInfo = input.signatureInfo
            this.mainImpactPoint = input.mainImpactPoint
            this.ctpImpactPoint = input.ctpImpactPoint

            this.ctpTypeTarga = input.ctpTypeTarga
        }
    }
}

export class FronteRetroFileItemType {
    public front: FileItemType[] = []
    public retro: FileItemType[] = []

    constructor(input?: any) {
        if (input) {
            this.front = ((input && input.front) || []).map((f: any) => new FileItemType(f))
            this.retro = ((input && input.retro) || []).map((f: any) => new FileItemType(f))
        }
    }
}

export class FileItemType {
    // Result Data
    public file_type: string = '';
    public _id: string = '';
    public mimetype: string = '';
    public name: string = '';
    public timestamp: string = '';
    public value: string[] = [];
    public metadata: MetadataType = new MetadataType()
    public token: string = '';
    public additionalBeInfo?: any;

    constructor(input?: any) {
        if (input) {
            this.file_type = input.file_type;
            this._id = input._id;
            this.mimetype = input.mimetype;
            this.name = input.name;
            this.timestamp = input.timestamp;
            this.value = input.value || [];
            this.metadata = new MetadataType(input.metadata)
            this.token = input.token;
            this.additionalBeInfo = input.additionalBeInfo;
        }
    }
}

export enum ZonaUrtoEnum {
    "TOP-LEFT" = 'TOP-LEFT',
    "TOP-CENTER" = 'TOP-CENTER',
    "TOP-RIGHT" = 'TOP-RIGHT',
    "CENTER-LEFT" = 'CENTER-LEFT',
    "CENTER-CENTER" = 'CENTER-CENTER',
    "CENTER-RIGHT" = 'CENTER-RIGHT',
    "BOTTOM-LEFT" = 'BOTTOM-LEFT',
    "BOTTOM-CENTER" = 'BOTTOM-CENTER',
    "BOTTOM-RIGHT" = 'BOTTOM-RIGHT',
    "OTHER" = 'OTHER',
}

export enum TypeTargaEnum {
    TARGA_ITALIA = 'T',
    TARGA_ESTERA = 'E',
    TARGA_PROVVISORIA = 'Y',
    TARGA_PROVA = 'X',
    TARGA_FILOBUS = 'J',
}

export interface ViewerLink {
    userRole: UserRoleEnum
    authType: SignAuthType
    outcome?: UserSignResEnum
    telNumber?: string

    activityId: string
    email: string
    viewerLink: string
}

export enum UserSignResEnum {
    CAI_ACCEPTED = 'CAI_ACCEPTED',
    CAI_REFUSED = 'CAI_REFUSED',
    NOT_EDITED = 'NOT_EDITED'
}

export interface SignatureInfoType {
    envelopeId: string
    fileId: string,
    viewerLinks: ViewerLink[]
    isMonoSignature?: boolean
}


export enum SignAuthType {
    SPID = 'SPID',
    CIE = 'CIE',
    ALTERNATIVE_METHOD = 'ALTERNATIVE_METHOD',
    CLICK_TO_SIGN = 'CLICK_TO_SIGN'
}

export class ZoneUrtoType {
    // Result Data
    public file?: FileItemType;
    public position?: ZonaUrtoEnum;
    public isSelected?: boolean;

    constructor(input?: Partial<ZoneUrtoType>) {
        if (input) {
            this.file = input && input.file ? new FileItemType(input.file) : undefined;
            this.position = input && input.position;
            this.isSelected = !!input && input.isSelected;
        }
    }
}

export class AniaItemType {
    public value: string = '';
    public label: string = '';

    constructor(input?: any) {
        if (input) {
            this.value = input.value;
            this.label = input.label;
        }
    }
}

export type FileActionFunction = (file?: FileItemType) => void;
export type setFilesActionFunction = (files: FileItemType[]) => any;

export enum EventValueEnum {
    SHOW_CAPTCHA = 'SHOW_CAPTCHA',
    CAI_FILLING_START = 'CAI_FILLING_START',
    FREE_CTP_CAI_FILLING = 'FREE_CTP_CAI_FILLING',
    IS_CLAIM_NOT_CONFIRMED = 'IS_CLAIM_NOT_CONFIRMED',
    NEGATION_REASON_CONFIRMED = 'NEGATION_REASON_CONFIRMED',
    IS_RCA = 'is_rca',
    IS_RCA_MANY = 'is_rca_many',
    IS_KASKO = 'is_kasko',
    POSITION_MODIFIED = 'POSITION_MODIFIED', //TODO: DA IMPLEMENTARE AL CAMBIO LUOGO
    WONT_PROCEED_DIGITAL_SIGN = 'WONT_PROCEED_DIGITAL_SIGN', //TODO: DA IMPLEMENTARE AL NON VOGLIO FIRMARE
    SMS_SENDING_REQUEST = 'SMS_SENDING_REQUEST',
    SMS_SENDING_SUCCESS = 'SMS_SENDING_SUCCESS',
    SMS_SENDING_ERROR = 'SMS_SENDING_ERROR',
    CAI_FILLING_END = 'CAI_FILLING_END', // TODO: AGGIUNGERE AL CLICK DELLA FIRMA
    FORWARD_COMMUNICATION = 'FORWARD_COMMUNICATION',
    CAI_TAKE_CONTROL_AFTER_FORWARD = 'CAI_TAKE_CONTROL_AFTER_FORWARD',
    CONFIRMED = 'HRM-02',
    MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
    MESSAGE_RX_FAILED = 'MESSAGE_RX_FAILED',
    FIRST_ACCESS = 'FIRST_ACCESS',
    CAPTCHA_SHOW = 'CAP-01',
    CAPTCHA_SUCCESS = 'CAP-02',
    CAPTCHA_ERROR = 'CAP-03',
    OPEN_CLAIM = 'OPEN_CLAIM',
    IS_CLAIM_CONFIRMED = 'IS_CLAIM_CONFIRMED',
    AUTH_CONFIRM_CHECK_CTP_CORRECT_PLATE = 'AUTH_CONFIRM_CHECK_CTP_CORRECT_PLATE',
    AUTH_CONFIRM_END_CANCEL = 'AUTH_CONFIRM_END_CANCEL',
    AUTH_CONFIRM_END_SUCCESS = 'AUTH_CONFIRM_END_SUCCESS',
    AUTH_CONFIRM_PLATE_CHECK_SUCCESS = 'AUTH_CONFIRM_PLATE_CHECK_SUCCESS',
    AUTH_CONFIRM_PREVIEW_ACCEPTED = 'AUTH_CONFIRM_PREVIEW_ACCEPTED',
    AUTH_CONFIRM_STEPS_COMPLETED = 'AUTH_CONFIRM_STEPS_COMPLETED',
    CAI_PAPER_UPLOADED = 'CAI_PAPER_UPLOADED',
    FREE_CTP_TOWARD_CAI_PAPER = 'FREE_CTP_TOWARD_CAI_PAPER',
    PROCEDURE_CANCELED = 'PROCEDURE_CANCELED',
    SIGNATURE_FOLDER_OUTCOME = 'SIGNATURE_FOLDER_OUTCOME',
    USER_SIGNATURE_OUTCOME = 'USER_SIGNATURE_OUTCOME',
    USER_SIGNATURE_OUTCOME_CALLED = 'USER_SIGNATURE_OUTCOME_CALLED',
    USER_ENVELOPE_OUTCOME_CALLED = 'USER_ENVELOPE_OUTCOME_CALLED',
    //linear
    LINEAR_ERROR_LINK_ALREADY_FORWARDED = 'LINEAR_ERROR_LINK_ALREADY_FORWARDED',
    LINEAR_ERROR_FORWARDING_LINK = 'LINEAR_ERROR_FORWARDING_LINK',
    LINEAR_COMMUNICATION_OPENED = 'LINEAR_COMMUNICATION_OPENED',
    LINEAR_DRIVER_QUESTION_SHOW = 'LINEAR_DRIVER_QUESTION_SHOW',
    LINEAR_DRIVER_ANSWER_Y = 'LINEAR_DRIVER_ANSWER_Y',
    //LINEAR_DRIVER_ANSWER_N = 'LINEAR_DRIVER_ANSWER_N',
    LINEAR_DRIVER_STATEMENT_REJECTED = 'LINEAR_DRIVER_STATEMENT_REJECTED',    // non vuole inoltrare la comunicazione
    LINEAR_DRIVER_INFO_SUBMITTED = 'LINEAR_DRIVER_INFO_SUBMITTED',
    LINEAR_REFUSE_TO_SEND_COMMUNICATION = 'LINEAR_REFUSE_TO_SEND_COMMUNICATION',
    LINEAR_LINK_FORWARDED_TO_DRIVER = 'LINEAR_LINK_FORWARDED_TO_DRIVER',
    LINEAR_CAI_PRESENTATION_SHOW = 'LINEAR_CAI_PRESENTATION_SHOW',
    LINEAR_AGREEMENT_QUESTION_SHOW = 'LINEAR_AGREEMENT_QUESTION_SHOW',
    LINEAR_CONFIRM_AGREEMENT_WITH_CTP = 'LINEAR_CONFIRM_AGREEMENT_WITH_CTP',
    LINEAR_REFUSE_AGREEMENT_WITH_CTP = 'LINEAR_REFUSE_AGREEMENT_WITH_CTP',
    LINEAR_START_SIGNATURE_SEND_FOR_CTP_AUTH = 'LINEAR_START_SIGNATURE_SEND_FOR_CTP_AUTH',
    LINEAR_START_ONE_SIGNATURE = 'LINEAR_START_ONE_SIGNATURE',
    LINEAR_UPLOADED_COMPLAIN_AND_PROCEED = 'LINEAR_UPLOADED_COMPLAIN_AND_PROCEED',
    LINEAR_UPLOADED_OPTIONAL_DOCS_AND_PROCEED = 'LINEAR_UPLOADED_OPTIONAL_DOCS_AND_PROCEED',
    ONUS_CALL = 'ONUS_CALL',
    ONUS_CALL_SUCCESS = 'ONUS_CALL_SUCCESS',
    ONUS_CALL_FAILURE = 'ONUS_CALL_FAILURE',
    LINEAR_SEND_DOCUMENTS = 'LINEAR_SEND_DOCUMENTS',
    LINEAR_CONFIRM_STEPS_COMPLETED = 'LINEAR_CONFIRM_STEPS_COMPLETED',

    LINEAR_IGNORED_CAI = 'LINEAR_IGNORED_CAI',
    SKIPPED_QUESTION_CAUSE_EXPIRING_48H = 'SKIPPED_QUESTION_CAUSE_EXPIRING_48H'

}

export class EventCommType {
    // Result Data
    public receiving_timestamp: string = '';
    public timestamp: string = '';
    public value?: EventValueEnum;
    public env: string = '';
    public metadata: EvMetadataType = {};

    constructor(input?: any) {
        if (input) {
            this.receiving_timestamp = input.receiving_timestamp;
            this.timestamp = input.timestamp || moment();
            this.value = input.value;
            this.env = input.env;
            this.metadata = input.metadata;
        }
    }
}

export class InteractionType {
    // Result Data
    public _id: string = '';
    public file_type: string = '';
    public name: string = '';
    public value: string[] = [];
    public timestamp: string = '';
    public token: string = '';
    public metadata: MetadataType = new MetadataType()

    constructor(input?: any) {
        if (input) {
            this._id = input._id;
            this.file_type = input.file_type;
            this.name = input.name;
            this.value = input.value || [];
            this.timestamp = input.timestamp;
            this.token = input.token;
            this.metadata = new MetadataType(input.metadata)
        }
    }
}

export class ConducenteInfo {
    public alsoOwner?: BoolStringEnum;
    public y_contactInfo: ContactInfo = new ContactInfo();
    public n_contactInfo: ContactInfo = new ContactInfo();

    constructor(input?: any) {
        if (input) {
            this.alsoOwner = input.alsoOwner;
            this.y_contactInfo = new ContactInfo(input.y_contactInfo);
            this.n_contactInfo = new ContactInfo(input.n_contactInfo);
        }
    }
}

export class ControparteInfo {
    public alsoOwner?: BoolStringEnum;
    public y_ctp_contactInfo: ContactInfo = new ContactInfo();
    public n_ctp_contactInfo: ContactInfo = new ContactInfo();
    public dn_ctp_contactInfo: ContactInfo = new ContactInfo();

    constructor(input?: any) {
        if (input) {
            this.alsoOwner = input.alsoOwner;
            this.y_ctp_contactInfo = new ContactInfo(input.y_ctp_contactInfo);
            this.n_ctp_contactInfo = new ContactInfo(input.n_ctp_contactInfo);
            this.dn_ctp_contactInfo = new ContactInfo(input.dn_ctp_contactInfo);
        }
    }
}

export class LinearControparteInfo {
    public agreeWithCtp?: boolean;
    public agree_contactInfo: LinearContactInfo = new LinearContactInfo();

    constructor(input?: any) {
        if (input) {
            this.agreeWithCtp = input.agreeWithCtp;
            this.agree_contactInfo = new LinearContactInfo(input.agree_contactInfo);
        }
    }
}

export class LinearConducenteInfo {
    public insuredIsDriver?: boolean;
    public conducente_contactInfo: LinearContactInfo = new LinearContactInfo();

    constructor(input?: any) {
        if (input) {
            this.insuredIsDriver = input.insuredIsDriver;
            this.conducente_contactInfo = new LinearContactInfo(input.conducente_contactInfo);
        }
    }
}

export class
    OtherContactInfo {
    public isPresent?: BoolStringEnum;
    public contactList: ContactInfo[] = []
    constructor(input?: Partial<OtherContactInfo>) {
        if (input) {
            this.isPresent = input.isPresent;
            this.contactList = ((input && input.contactList) || []).map((f: Partial<ContactInfo>) => new ContactInfo(f))

        }
    }
}

export class RimorchioInfo {
    public trainavaRimorchio?: BoolStringEnum;
    public targa: string = '';
    public stato_immatricolazione: string = '';

    constructor(input?: any) {
        if (input) {
            this.trainavaRimorchio = input.trainavaRimorchio;
            this.targa = input.targa;
            this.stato_immatricolazione = input.stato_immatricolazione;
        }
    }
}

export class ContactInfo {
    public _id: string = '';
    public name: string = '';
    public surname: string = '';
    public phoneNumber: string = '';
    public email: string = '';
    public targa: string = '';
    public nameSurname: string = '';
    public description: string = '';
    public isPassenger?: BoolStringEnum;

    constructor(input?: any) {
        if (input) {
            this._id = input._id;
            this.name = input.name;
            this.surname = input.surname;
            this.phoneNumber = input.phoneNumber;
            this.email = input.email;
            this.targa = input.targa;
            this.nameSurname = input.nameSurname;
            this.description = input.description;
            this.isPassenger = input.isPassenger;
        }
    }
}

export class LinearContactInfo {
    public name: string = '';
    public surname: string = '';
    public phoneNumber: string = '';

    constructor(input?: any) {
        if (input) {
            this.name = input.name;
            this.surname = input.surname;
            this.phoneNumber = input.phoneNumber;
        }
    }
}

export interface ContactInfoItemUi {
    propName: keyof ContactInfo;
    label?: string;
    className?: string;
    type?: InputType;
    options?: ValueLabelOption<BoolStringEnum>[];
    otpionsLabel?: string;
}

export interface LinearContactInfoItemUi {
    propName: keyof LinearContactInfo;
    label?: string;
    className?: string;
    placeholder?: string;
    type?: InputType;
    options?: ValueLabelOption<BoolStringEnum>[];
    otpionsLabel?: string;
    companyName?: string;
}

export enum InputType {
    TEXT = 'TEXT',
    RADIO = 'RADIO',
    TEXTAREA = 'TEXTAREA',
}
export const otherPeople_contactInfoItems: ContactInfoItemUi[] = [{
    propName: 'nameSurname',
    label: 'Nome e cognome',
    className: 'upper'
}, {
    propName: 'phoneNumber',
    label: 'Numero di telefono',
    className: 'upper'
}, {
    propName: 'isPassenger',
    label: 'Passeggero del veicolo?',
    type: InputType.RADIO,
    options: booleanRadioOptions,
    otpionsLabel: 'Passeggero del veicolo?'
}]


export const otherVehicles_contactInfoItems: ContactInfoItemUi[] = [{
    propName: 'targa',
    label: 'Targa(*)',
    className: 'upper'
}, {
    propName: 'nameSurname',
    label: 'Nome e cognome',
    className: 'upper'
}, {
    propName: 'phoneNumber',
    label: 'Numero di telefono',
    className: 'upper'
}]

export const otherObjects_contactInfoItems: ContactInfoItemUi[] = [{
    propName: 'description',
    label: 'Descrizione',
    type: InputType.TEXTAREA,
}]

export const linear_controparteCtp_contactInfoItems: LinearContactInfoItemUi[] = [
    {
        propName: 'phoneNumber',
        label: 'Numero di telefono della controparte',
        placeholder: "Inserisci il numero",
        companyName: "LINEAR"
    }, {
        propName: 'name',
        label: 'Nome conducente di controparte',
        placeholder: "Inserisci il nome",
        companyName: "LINEAR"
    }, {
        propName: 'surname',
        label: 'Cognome conducente di controparte',
        placeholder: "Inserisci il cognome",
        companyName: "LINEAR"
    }]

export const linear_conducenteCtp_contactInfoItems: LinearContactInfoItemUi[] = [
    {
        propName: 'phoneNumber',
        label: 'Numero di telefono del conducente',
        placeholder: "Inserisci il numero",
        companyName: "LINEAR"
    }, {
        propName: 'name',
        label: 'Nome del conducente',
        placeholder: "Inserisci il nome",
        companyName: "LINEAR"
    }, {
        propName: 'surname',
        label: 'Cognome del conducente',
        placeholder: "Inserisci il cognome",
        companyName: "LINEAR"
    }]

const linearBaseValidationSchema = {
    name: yup.string().required(messageRequired),
    surname: yup.string().required(messageRequired),
    phoneNumber: yup.number().test(
        'len',
        'Numero di telefono non valido',
        function (val) {
            if (val === undefined) {
                return true;
            }
            const length = val.toString().length;
            if (length === 0) {
                return true;
            }
            if (length < 8) {
                return this.createError({ message: 'Il numero inserito è troppo corto' });
            }
            if (length > 16) {
                return this.createError({ message: 'Il numero inserito è troppo lungo' });
            }
            return true;
        }
    ).typeError(numberFormat).required(messageRequired)
}

export const completeLinearBaseValidationSchema = yup.object().shape(linearBaseValidationSchema);

export const conducente_contactInfoItems: ContactInfoItemUi[] = [{
    propName: 'name',
    label: 'Il tuo nome (*)',
    className: 'upper'
}, {
    propName: 'surname',
    label: 'Il tuo cognome (*)',
    className: 'upper'
}, {
    propName: 'email',
    label: 'La tua email (*)'
}]

export const ctp_conducente_contactInfoItems: ContactInfoItemUi[] = [{
    propName: 'name',
    label: 'Nome (*)',
    className: 'upper'
}, {
    propName: 'surname',
    label: 'Cognome (*)',
    className: 'upper'
}, {
    propName: 'email',
    label: 'Email'
}]

export const conducente_noIntestatario_contactInfoItems: ContactInfoItemUi[] = [
    conducente_contactInfoItems[0],
    conducente_contactInfoItems[1], {
        propName: 'phoneNumber',
        label: 'Il tuo numero di telefono (*)'
    },
    conducente_contactInfoItems[2]
]

export const ctp_conducente_noIntestatario_contactInfoItems: ContactInfoItemUi[] = [
    ctp_conducente_contactInfoItems[0],
    ctp_conducente_contactInfoItems[1], {
        propName: 'phoneNumber',
        label: 'Numero di telefono (*)'
    },
    ctp_conducente_contactInfoItems[2]
]

const baseValidationSchema = {
    name: yup.string().required(messageRequired),
    surname: yup.string().required(messageRequired),
    email: yup.string().required(messageRequired).email(emailFormatMessage)
}

const completeValidationSchema = {
    ...baseValidationSchema,
    phoneNumber: yup.number().test(
        'len',
        numberFormatLength,
        (val) => {
            if (val === undefined) {
                return true;
            }
            return ((val.toString().length === 0 || (val.toString().length >= 8 && val.toString().length <= 16)))
        }
    ).typeError(numberFormat).required(messageRequired)
}

export const contactInfoSchema = yup.object().shape(baseValidationSchema);

export const contactInfoSchema_OptionalMail = yup.object().shape({
    ...baseValidationSchema,
    email: yup.string().email(emailFormatMessage)
});

export const contactCompleteInfoSchema = yup.object().shape(completeValidationSchema);

export const contactCompleteInfoSchema_OptionalMail = yup.object().shape({
    ...completeValidationSchema,
    email: yup.string().email(emailFormatMessage)
});

export const emptyValidationSchema = yup.object().shape({});

export const allPossibleZoneUrto: Partial<ZoneUrtoType>[] = [
    {
        position: ZonaUrtoEnum["TOP-LEFT"]
    }, {
        position: ZonaUrtoEnum["TOP-CENTER"]
    }, {
        position: ZonaUrtoEnum["TOP-RIGHT"]
    },
    {
        position: ZonaUrtoEnum["CENTER-LEFT"]
    }, {
        position: ZonaUrtoEnum["CENTER-CENTER"]
    }, {
        position: ZonaUrtoEnum["CENTER-RIGHT"]
    },
    {
        position: ZonaUrtoEnum["BOTTOM-LEFT"]
    }, {
        position: ZonaUrtoEnum["BOTTOM-CENTER"]
    }, {
        position: ZonaUrtoEnum["BOTTOM-RIGHT"]
    }
]

export enum CarInvolvedEnum {
    NS = 'NS',
    CTP = 'CTP',
    BOTH = 'BOTH',
}
export class BaremeInfo {
    public idNs?: string;
    public idCtp?: string;
    public description?: string;
    public assInRetro?: boolean;
    public ctpInRetro?: boolean;

    constructor(input?: Partial<BaremeInfo>) {
        this.idNs = input?.idNs;
        this.idCtp = input?.idCtp;
        this.description = input?.description;
        this.assInRetro = !!input?.assInRetro;
        this.ctpInRetro = !!input?.ctpInRetro;
    }

    fillFields(id?: string, description?: string, carInvolved?: CarInvolvedEnum) {
        if (carInvolved === CarInvolvedEnum.NS) {
            this.idNs = id;
        } else if (carInvolved === CarInvolvedEnum.CTP) {
            this.idCtp = id;
        } else if (carInvolved === CarInvolvedEnum.BOTH) {
            this.idNs = id;
            this.idCtp = id;
        }
        this.description = description;
    }
}

export const enum UserTypeEnum {
    IPER_NATURALE = 'IPER_NATURALE',
    SUPER_NATURALE = 'SUPER_NATURALE',
    NON_NATURALE = 'NON_NATURALE'
}